import { create } from 'zustand';
import {
  VenueFilterData,
  VenueIndexData,
  VenueTagData,
} from '../dto/EntityRepository';
import { getDefaultVenueFilterData } from '../util/venueListParams';
import {
  InterestExhibitionCardData,
  mergeInterestExhibitionCards,
  removeInterestExhibitionCard,
  removeInterestExhibitionCardsByVenue,
} from '../util/interestExhibitions';

interface ExhibitionVenueState {
  venueList: VenueIndexData[];
  interestExhibitions: InterestExhibitionCardData[];
  venueExhibitionCache: Record<string, InterestExhibitionCardData[]>;
  loadingVenueIds: string[];
  filterData: VenueFilterData;
  tags: VenueTagData[];
  setVenueList: (venueList: VenueIndexData[]) => void;
  addInterestExhibitions: (exhibitions: InterestExhibitionCardData[]) => void;
  removeInterestExhibition: (key: string) => void;
  removeInterestVenue: (venueId: string) => void;
  setVenueExhibitionCache: (
    venueId: string,
    exhibitions: InterestExhibitionCardData[],
  ) => void;
  setVenueLoading: (venueId: string, isLoading: boolean) => void;
  setFilterData: (filterData: VenueFilterData) => void;
  setTags: (tags: VenueTagData[]) => void;
}

export const useExhibitionVenueStore = create<ExhibitionVenueState>((set) => ({
  venueList: [],
  interestExhibitions: [],
  venueExhibitionCache: {},
  loadingVenueIds: [],
  filterData: getDefaultVenueFilterData(),
  tags: [],
  setVenueList: (venueList) => set({ venueList }),
  addInterestExhibitions: (exhibitions) => set((state) => ({
    interestExhibitions: mergeInterestExhibitionCards(
      state.interestExhibitions,
      exhibitions,
    ),
  })),
  removeInterestExhibition: (key) => set((state) => ({
    interestExhibitions: removeInterestExhibitionCard(
      state.interestExhibitions,
      key,
    ),
  })),
  removeInterestVenue: (venueId) => set((state) => ({
    interestExhibitions: removeInterestExhibitionCardsByVenue(
      state.interestExhibitions,
      venueId,
    ),
  })),
  setVenueExhibitionCache: (venueId, exhibitions) => set((state) => ({
    venueExhibitionCache: {
      ...state.venueExhibitionCache,
      [venueId]: exhibitions,
    },
  })),
  setVenueLoading: (venueId, isLoading) => set((state) => ({
    loadingVenueIds: isLoading
      ? state.loadingVenueIds.includes(venueId)
        ? state.loadingVenueIds
        : [...state.loadingVenueIds, venueId]
      : state.loadingVenueIds.filter((id) => id !== venueId),
  })),
  setFilterData: (filterData) => set({ filterData }),
  setTags: (tags) => set({ tags }),
}));
